import { createSlice } from '@reduxjs/toolkit';
import { getReviewById, getReviewByOrder, getReviews } from './actions';

const initialState = {
  list: {},
  byId: {},
  byOrder: [],
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const reviews = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReviews.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.list = {};
      })
      .addCase(getReviews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getReviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getReviewByOrder.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.byOrder = [];
      })
      .addCase(getReviewByOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getReviewByOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byOrder = action.payload;
      })
      .addCase(getReviewById.pending, (state) => {
        // state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.byId = {};
      })
      .addCase(getReviewById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getReviewById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId = action.payload;
      });
  },
});

export default reviews.reducer;
